module.exports = __webpack_public_path__ + "img/ms.0c2725c5.jpg";